import React, {
  useCallback,
  useMemo,
} from 'react'

import { FormattedMessage } from 'react-intl'

import TCFTabNames from 'constants/tcf-tab-names'
import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'
import { useTCF } from 'components/TCFProvider'

import makeTextLinkRenderer from '../lib/makeTextLinkRenderer'

import Locale from './locale'


export default function VendorParagraph() {
  const { pushActiveUI } = useDisplayManager()

  const { gvl } = useTCF()

  const handleVendorClick = useCallback(() => {
    pushActiveUI(UINames.PREFERENCES, {
      tabName: TCFTabNames.VENDORS,
    })
  }, [pushActiveUI])

  const values = useMemo(() => {
    const renderLink = makeTextLinkRenderer({
      dataTid: 'vendor-link',
      handleClick: handleVendorClick,
    })

    return {
      vendorCount: gvl.getVendorCount(),
      vendorLink: (chunks) => (
        <b>{ renderLink(chunks) }</b>
      ),
    }
  }, [gvl, handleVendorClick])

  return (
    <FormattedMessage
      { ...Locale.weAndOurVendors }
      values={ values }
    />
  )
}
